import { ScrollArea } from '../scrollArea'
import { Separator } from '../separator'
import { Skeleton } from '../skeleton'

const NotificationPopoverContentSkeleton = () => {
  return (
    <section className="flex flex-col">
      <div className="flex items-center justify-between p-4 pb-0">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-4 w-32" />
      </div>

      <ScrollArea>
        <div className="flex max-h-72 flex-col">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className="flex flex-col gap-3 border-b border-b-system-border-secondary p-4"
            >
              <div className="flex items-start gap-3">
                <Skeleton className="size-8 rounded-full" />
                <div className="flex w-full flex-col gap-3">
                  <div className="flex flex-col gap-2">
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-3 w-full" />
                    <Skeleton className="h-3 w-1/2" />
                  </div>

                  <div className="flex items-center gap-3">
                    <Separator
                      orientation="vertical"
                      className="h-6 w-[2px] bg-muted"
                      decorative={false}
                    />
                    <Skeleton className="h-3 w-2/3" />
                  </div>

                  <div className="flex items-center justify-between">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-3 w-24" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </ScrollArea>

      <div className="flex items-center justify-center rounded-b-md bg-system-grey-light py-5">
        <Skeleton className="h-4 w-40" />
      </div>
    </section>
  )
}
NotificationPopoverContentSkeleton.displayName =
  'NotificationPopoverContentSkeleton'

export { NotificationPopoverContentSkeleton }
